import { vuexOidcCreateNuxtRouterMiddleware } from 'vuex-oidc'

export default vuexOidcCreateNuxtRouterMiddleware('oidc')
